import { useMemo } from "react"
import { MaterialReactTable, type MRT_ColumnDef } from "material-react-table"
import { Box } from "@mui/material"
import { useNavigate } from "react-router"
import { useAppSelector } from "../../../redux/hooks"
import { splitFirstCap } from "../../../../helper/utils"
import { StatusButton } from "../../Button"
import UserTableGroupInfoCell from "../Cell/UserTableGroupInfoCell"
import UsersTableMenu from "../../Menu/UsersTableMenu"
import SortIcon from "@mui/icons-material/Sort"
import SyncAltIcon from "@mui/icons-material/SyncAlt"
import moment from "moment"
import { useDispatch } from "react-redux"
import { setSelectedUserId } from "../../../redux/slices/userSlice"
export type User = {
  name: string
  email: string
  role: string
  status: string
  customerGroups: number
  contact: any
  actions: any
}

export const UsersTable = (props: any) => {
  const { handleUserActivationActionOpen } = props
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading } = useAppSelector((state: any) => state.app)
  const { usersData } = useAppSelector((state: any) => state.users)

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "uid",
        header: "User Name",
        Cell: ({ row }) => (
          <Box
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: "#3D76EF",
              },
            }}
            onClick={() => {
              console.log("row?.original?.uid", row?.original?.uid)

              dispatch(setSelectedUserId(row?.original?.uid))

              navigate("/user-profile")
            }}
          >
            {`${row?.original?.first_name} ${row?.original?.last_name}`}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "email",
        header: "Email",
        muiTableBodyCellProps: () => ({
          sx: {
            color: "#3D76EF",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "role_id",
        header: "User Role Type",
        Cell: ({ renderedCellValue, row }) => (
          <Box>{splitFirstCap(row.original.role_display_name, "_")}</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
      },
      {
        accessorKey: "status",
        header: "Status",

        Header: ({ column }) => (
          <span style={{ paddingRight: " 10px" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ renderedCellValue }) => (
          <StatusButton
            status={renderedCellValue}
            fontSize={12}
            padding="medium"
          />
        ),
      },
      {
        accessorKey: "associated_groups.count",
        header: "Groups/Practices",
        Cell: ({ cell, renderedCellValue, row }) => (
          <UserTableGroupInfoCell
            renderedCellValue={renderedCellValue}
            cell={cell}
            row={row}
          />
        ),
      },
      {
        accessorKey: "createdAt",
        header: "Created At",
        Cell: ({ cell, renderedCellValue }: any) => (
          <Box>
            {renderedCellValue
              ? moment(renderedCellValue).format("MM/DD/YYYY H:mm")
              : `-`}
          </Box>
        ),
      },
    ],
    [usersData],
  )

  return (
    <MaterialReactTable
      state={{
        isLoading: loading,
      }}
      columns={columns}
      data={usersData}
      enableStickyHeader={true}
      enableColumnActions={false}
      enableColumnFilters={false}
      enablePagination={false}
      enableSorting={true}
      enableBottomToolbar={false}
      enableTopToolbar={false}
      muiTableBodyRowProps={{ hover: false, sx: { height: "60px" } }}
      muiTableContainerProps={{
        sx: {
          marginTop: "4px",
          height: "70vh",
          fontSize: 14,
          "& td": {
            cursor: "pointer",
          },
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "#3366D6",
          color: "#FFFFFF",
          border: "0.5px solid #FFFFFF",
        },
      }}
      muiTableBodyCellProps={{
        sx: {
          height: "48px",
          border: "0.5px solid #E4E4E4",
        },
      }}
      icons={{
        ArrowDownwardIcon: (props: any) => {
          return <SortIcon sx={{ fill: "#fff" }} {...props} />
        },
        SyncAltIcon: (props: any) => {
          return <SyncAltIcon sx={{ fill: "#fff" }} {...props} />
        },
      }}
    />
  )
}

export default UsersTable
